import styled from 'styled-components'

export const IntervalSelectionStyled = styled.div`
  width: 120px;
  display: flex;
  cursor: pointer;
  height: 40px;
  ${({ theme }) => theme.mediaWidth.Small`
    width: 240px;
    position: relative;
    left: calc(100% - 240px);
  `}
`

export const SelectedItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 75px;
  align-items: center;
  padding: 0 20px 0 20px;
`

export const IntervalSelectionContainer = styled.div`
  position: absolute;
  z-index: 2;
  right: 0px;
  border-radius: 20px;
  padding: 20px;
  background-color: ${({ theme }) => theme.bg};
  top: 18px;
  ${({ theme }) => theme.mediaWidth.Small`
    top: unset;    
  `}
`
